<template>
    <main class="grace-container">
        <section class="slogan">
            <div class="slogan-img"></div>
            <div class="main-title-wrapper">
                <div class="main-title">{{ $t('lp-zoho7') }}</div>
                <div class="main-subtitle">{{ $t('lp-zoho8') }}</div>
                <nuxt-link class="submit-btn" :to="localePath('/trading-desk/EnPrimeur')" place="action">{{ $t('lp-zoho9') }}</nuxt-link>
            </div>
        </section>

        <div class="why-invest-wrapper why-invest-wrapper-grey">
            <div class="container">
                <div class="collections-h1">{{ $t('en-primeur1') }}</div>
                <div class="card-text card-text2">{{ $t('lp-zoho11') }}</div>
                <v-row>
                    <v-col class="col-md-4 right-half-padding">
                        <div class="how-icon primeur1">
                            <div class="card-icon"></div>
                            <div class="card-text">{{ $t('en-primeur3') }}</div>
                        </div>
                    </v-col>
                    <v-col class="col-md-4 right-half-padding left-half-padding">
                        <div class="how-icon primeur2">
                            <div class="card-icon"></div>
                            <div class="card-text">{{ $t('en-primeur4') }}</div>
                        </div>
                    </v-col>
                    <v-col class="col-md-4 left-half-padding">
                        <div class="how-icon primeur3">
                            <div class="card-icon"></div>
                            <div class="card-text">{{ $t('en-primeur5') }}</div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="why-invest-wrapper">
            <div class="container">
                <h2 v-if="popularEnWines.length" class="home-title">{{ $t('latest-offers') }}</h2>
                <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>

                <a href="/trading-desk/EnPrimeur" class="browse-market-btn">{{ $t('popular-wines2') }}</a>
            </div>
        </div>

        <div class="why-invest-container2">
            <div class="container">
                <div class="collections-h1">{{ $t('lp-zoho12') }}</div>

                <div class="features-wrapper">
                    <div class="features-left"></div>
                    <div class="features-right">
                        <div class="features-right-row">
                            <div class="features-title">{{ $t('lp-zoho13') }}</div>
                            <div class="features-subtitle">{{ $t('lp-zoho14') }}</div>
                        </div>
                        <div class="features-right-row">
                            <div class="features-title">{{ $t('lp-zoho15') }}</div>
                            <div class="features-subtitle">{{ $t('lp-zoho16') }}</div>
                        </div>
                        <div class="features-right-row">
                            <div class="features-title">{{ $t('lp-zoho17') }}</div>
                            <div class="features-subtitle">{{ $t('lp-zoho18') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="why-invest-wrapper">
            <div class="container">
                <div class="collections-h1">{{ $t('lp-zoho19') }}</div>
                <div class="contact-wrapper">
                    <div class="contact-left">
                        <ul>
                            <li>{{ $t('lp-zoho20') }}</li>
                            <li>{{ $t('lp-zoho21') }}</li>
                            <li>{{ $t('lp-zoho22') }}</li>
                        </ul>
                    </div>
                    <div class="contact-right">
                        <iframe v-if="$i18n.locale === 'it'" frameborder="0" style="height:230px;width:100%;border:none;" src='https://forms.zohopublic.eu/vindome/form/EnPrimeurPurchaseCampaignIT/formperma/Mz6_cL6oy2oMcZPlLd1Bw7U4rUBSjotqE_1AckspYx0'></iframe>
                        <iframe v-else frameborder="0" style="height:230px;width:100%;border:none;" src='https://forms.zohopublic.eu/vindome/form/EnPrimeurPurchaseCampaignEN/formperma/EFyrdus-NDaOXEaueoX1J1MPTTU9ZdKqfzxJg3ylLOQ'></iframe>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators';
    import axios from "axios";
    import HomePopularWines from "../components/home/HomePopularWines";
    import {GMarket} from "@/store/getters";
    import {AMarket} from "@/store/actions";
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "LpZoho",
        head: {
            title: 'En Primeur purchase campaign #2 | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-landing-investor'
            }
        },
        components: {
            HomePopularWines
        },
        validations: {
            userEmail: {
                required,
                email
            },
            firstName: {
                required
            },
            lastName: {
                required
            }
        },
        computed: {
            popularEnWinesIds() {
                let _list = [];
                this.topEnWines.forEach(el => {
                    _list.push(el.wineId)
                });
                return _list
            },
            ...mapGetters({
                topWines: GMarket.GET_TOP_WINES,
                topEnWines: GMarket.GET_TOP_EN_WINES,
                wineItems: GMarket.GET_WINES
            })
        },
        data () {
            return {
                filtersObj: {
                    vintage: null,
                    countryId: null,
                    regionId: null,
                    appellationId: null,
                    producerId: null,
                    colorId: null,
                    priceFrom: null,
                    priceTo: null,
                    isEnPrimeur: true
                },
                popularEnWines: [],
                successMessageEn: false,
                userEmail: '',
                firstName: '',
                lastName: '',
                notes: '',
                errorMsg: '',
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || this.$i18n.t('required-field'),
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.reg.test(value) || this.$i18n.t('invalid-email')
                }
            }
        },
        methods: {
            ...mapActions({
                getWines: AMarket.GET_WINES
            })
        },
        created() {
            this.getWines(this.filtersObj);
            this.$store.dispatch(AMarket.GET_TOP_EN_WINES).then(() => {
                let homeCtrl = this;
                if (this.wineItems.length) {
                    this.wineItems.forEach(wine => {
                        if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1) {
                            homeCtrl.popularEnWines.push(wine)
                        }
                    })
                } else {
                    setTimeout(() => {
                        this.wineItems.forEach(wine => {
                            if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1) {
                                homeCtrl.popularEnWines.push(wine)
                            }
                        })
                    }, 1000)
                }

            });
        }
    }
</script>

<style scoped>
    .browse-market-btn {
        background: #CEA94B;
        padding: 0 10px;
        width: 380px;
        height: 32px;
        line-height: 33px;
        border-radius: 4px;
        font-family: Roboto, sans-serif;
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        display: block;
        margin: 0 auto 40px;
        text-align: center;
        text-decoration: none;
    }
    .home-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 19px;
        line-height: 120%;
        color: #303030;
        margin-top: 48px;
    }
    .login-label {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        position: absolute;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        color: #ffffff;
    }
    .submit-btn {
        background: #CEA94B;
        color: #FFF !important;
        min-width: 115px;
        height: 40px;
        font-weight: 700;
        font-size: 16px;
        line-height: 130%;
        text-transform: none;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        letter-spacing: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin: 18px auto 0;
        display: inline-block;
        border-radius: 4px;
        text-decoration: none;
        padding-top: 10px;
    }
    .contact-wrapper {
        max-width: 770px;
        margin: 75px auto 0;
    }
    .contact-left {
        display: inline-block;
        width: 360px;
        margin-right: 86px;
        vertical-align: top;
    }
    .contact-right {
        display: inline-block;
        width: 320px;
    }
    .contact-left ul {
        list-style-position: outside;
    }
    .contact-left li {
        font-family: Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 31px;
        color: #303030;
    }
    .container {
        max-width: 1100px;
        margin: 0 auto;
    }
    .slogan {
        height: 500px;
        position: relative;
    }
    .slogan-img {
        background: url('../assets/landing/lp-main8.png') no-repeat center top;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    .main-title-wrapper {
        position: absolute;
        left: calc((100% - 1032px)/2);
        text-align: center;
        top: 146px;
    }
    .main-title {
        width: 1032px;
        height: 35px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        display: block;
        color: #FFFFFF;
        margin-bottom: 32px;
        font-size: 38px;
        line-height: 46px;
        align-items: center;
        text-align: center;
    }
    .main-subtitle {
        width: 1032px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        display: block;
        color: #FFFFFF;
        margin-bottom: 30px;
        font-size: 28px;
        line-height: 34px;
    }
    h2 {
        color: #707070;
        margin-bottom: calc(2*var(--gutter));
    }

    .why-invest-wrapper {
        background: #ffffff;
        padding: 24px;
    }
    .why-invest-wrapper-grey {
        background: #F6F6F6;
    }
    .collections-h1 {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        text-align: center;
        color: #303030;
        margin-top: 24px;
        margin-bottom: 35px;
        font-size: 39.06px;
        line-height: 120%;
    }
    .card-text {
        margin-bottom: 11px;
        text-align: center;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 130%;
    }
    .card-text2 {
        max-width: 1150px;
        margin: -20px auto 20px;
        font-family: Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 130%;
    }
    .right-half-padding {
        padding-right: 25px;
    }
    .left-half-padding {
        padding-left: 25px;
    }
    .card-icon {
        height: 80px;
        width: 100%;
        margin-bottom: 20px;
    }
    .primeur1 .card-icon {
        background: url('../assets/home/price.png') no-repeat center center;
        background-size: contain;
    }
    .primeur2 .card-icon {
        background: url('../assets/home/chart.png') no-repeat center center;
        background-size: contain;
    }
    .primeur3 .card-icon {
        background: url('../assets/home/lock.png') no-repeat center center;
        background-size: contain;
    }
    .why-invest-container2 {
        background-color: #F6F6F6;
        padding: 24px 0 48px;
    }
    .features-wrapper {
        margin: 13px auto 0;
        padding: 48px 0;
        max-width: 1180px;
    }
    .features-left {
        height: 280px;
        width: 460px;
        display: inline-block;
        background: url('../assets/landing/enprimeur-img1.png') no-repeat center center;
    }
    .features-right {
        display: inline-block;
        margin-left: 100px;
        width: calc(100% - 564px);
        vertical-align: top;
    }
    .features-right-row {
        height: 93px;
    }
    .features-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 29px;
        color: rgba(0, 0, 0, 0.88);
    }
    .features-subtitle {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.88);
        margin-top: 8px;
    }

    @media (max-width: 767px) {
        .main-title {
            font-weight: 700;
            font-size: 26px;
            line-height: 30px;
            text-align: center;
            max-width: 100%;
            height: auto;
        }
        .main-subtitle {
            max-width: 100%;
            font-weight: 400;
            font-size: 18px;
            line-height: 21px;
            height: auto;
            margin-bottom: 10px;
            padding: 0 15px;
        }
        .main-title-wrapper {
            top: 180px;
            width: 100%;
            left: 0;
        }
        .browse-market-btn {
            width: 100%;
            margin-bottom: 10px;
            margin-top: 20px
        }
        .collections-h1 {
            font-size: 32px;
        }
        .features-left {
            width: 100%;
            background-size: contain;
        }
        .features-right {
            display: block;
            width: 100%;
            margin-left: 0;
        }
        .contact-left {
            width: 100%;
            margin-right: 0;
            margin-bottom: 30px;
        }
        .slogan {
            height: 550px;
        }
    }
</style>
<style>
.page-landing-investor .swiper-container {
    height: 400px;
}
    .page-landing-investor .v-main {
        padding-top: 0 !important;
    }
    .page-landing-investor .logo {
        display: block;
        margin: 0 auto;
        width: 206px;
    }
    .page-landing-investor .logo img {
        margin-top: 25px;
        width: 206px;
        height: 45px;
    }
    .page-landing-investor .theme--dark.v-sheet.header-toolbar.v-app-bar--is-scrolled .logo img {
        margin-top: 10px;
    }
    .page-landing-investor .nav-second-row,
    .page-landing-investor .nav-first-row-right {
        display: none;
    }

    .contact-form-container .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border: 0;
    }

    @media (max-width: 767px) {
        .page-landing-grace .theme--dark.v-sheet.header-toolbar,
        .page-landing-grace .theme--dark.v-sheet.header-toolbar .v-toolbar__content {
            height: 40px !important;
        }
        .page-landing-investor .v-application .hidden-md-and-up {
            display: none !important;
        }
        .page-landing-investor .logo,
        .page-landing-investor .logo img {
            width: 106px;
            margin: 0;
        }
        .page-landing-investor .logo {
            margin: 15px auto 0;
        }
        .why-invest-wrapper .row {
            display: block;
        }
        .why-invest-wrapper .col {
            width: 100%;
            display: block;
        }
    }
</style>
